import {DeviceAPI} from './API/DeviceAPI';

const deviceApi = new DeviceAPI();

/**
 * Maps action keys (stored in DeviceUrl.Actions) to their API call and translation key.
 * To add a new action: add an entry here and check the corresponding checkbox in ManageUrlDialog.
 */
const DEVICE_URL_ACTION_MAP = {
    shutdown: {
        labelKey: 'shutDown',
        execute: device => deviceApi.saveDeviceByUrl(device, "shutdown"),
    },
};

export default DEVICE_URL_ACTION_MAP;
